import React from 'react';
import { SIDEBAR_PANEL_WIDTH, sidebarPanelStyle } from '../constants/sidebarLayout';

const labelStyle = {
  ...sidebarPanelStyle,
  background:' #444a72',
  backdropFilter: 'blur(10px)',
  padding: '10px 20px',
  borderRadius: '12px',
  fontSize: '14px',
  fontFamily: "'Inter', sans-serif",
  color: 'white',
  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
  border: '1px solid rgba(0, 0, 0, 0.1);)',
  animation: 'fadeIn 0.3s ease-in-out',
  textAlign: 'center',
};

export default function HoverInfo({ date, time, value }) {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
      marginTop: '40px', // увеличенный отступ сверху
      alignItems: 'center',
    }}>
      <div style={labelStyle}>
        Date: {date || 'N/A'}
      </div>
      <div style={labelStyle}>
        Time: {time || 'N/A'}
      </div>
      <div style={labelStyle}>
        Value: {value ?? 'N/A'}
      </div>
    </div>
  );
}
